import React from 'react'
import { Pane } from 'evergreen-ui'
export const NumberAPI = ({ field }) => {
    return <Pane></Pane>
} 